import { AppleIcon, PlayIcon } from "@/components/site/Icons";

export default function StoreButtons({ settings, testIdPrefix = "store" }) {
  const buttons = [
    { href: settings?.app_store_url, label: "Download on the", name: "App Store", Icon: AppleIcon, id: "apple" },
    { href: settings?.play_store_url, label: "Get it on", name: "Google Play", Icon: PlayIcon, id: "play" },
  ];

  return (
    <div className="flex flex-wrap gap-3 justify-center lg:justify-start">
      {buttons.map(({ href, label, name, Icon, id }) => (
        <a
          key={id}
          href={href || "#"}
          target="_blank"
          rel="noopener noreferrer"
          data-testid={`${testIdPrefix}-${id}-btn`}
          className="group inline-flex items-center justify-center gap-3 w-full sm:w-auto sm:min-w-[205px] max-w-[280px] px-6 py-3.5 rounded-2xl border border-white/15 bg-[#0b0b0c] hover:border-ember hover:-translate-y-1 hover:shadow-[0_14px_40px_rgba(238,101,51,0.16)] transition-[transform,border-color,box-shadow] duration-300"
        >
          <Icon className="w-7 h-7 text-white group-hover:text-ember transition-colors" />
          <span className="text-left leading-tight">
            <span className="block text-[10px] tracking-wide text-white/45">{label}</span>
            <span className="block text-[17px] font-bold">{name}</span>
          </span>
        </a>
      ))}
    </div>
  );
}
